import { CarryOutFilled, SyncOutlined } from "@ant-design/icons";
import { Space, Typography } from "antd";
import React, { useState } from "react";
import { usePendingRequests } from "../../modules/PendingApprovalRequets/api/usePendingRequests ";
import { usePendingRequestsActions } from "../../modules/PendingApprovalRequets/api/useRefreshPendingRequests";
import { approvalDrawerHeaderStyles } from "./style/style";
import type { ApprovalDrawerHeaderProps } from "./types";

const { Text } = Typography;

const ApprovalDrawerHeader: React.FC<ApprovalDrawerHeaderProps> = ({ title }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { data } = usePendingRequests();
  const { refreshPendingRequests } = usePendingRequestsActions();
  const totalCount = data?.reduce((sum, group) => sum + group.count, 0) ?? 0;

  const handleRefreshClick = async () => {
    setIsRefreshing(true);
    try {
      await refreshPendingRequests();
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <Space direction="horizontal" size={10} align="start">
      {/* Icon */}
      <div style={approvalDrawerHeaderStyles.iconWrapper}>
        <CarryOutFilled style={approvalDrawerHeaderStyles.icon} />
      </div>

      {/* Title and Subtitle */}
      <div style={approvalDrawerHeaderStyles.titleContainer}>
        <Space size={6} align="center">
          <Text strong style={approvalDrawerHeaderStyles.titleText}>
            {title}
          </Text>
          <SyncOutlined
            style={{
              cursor: "pointer",
              fontSize: 15,
              color: "grey",
              marginTop: 7,
            }}
            title="Refresh pending requests"
            onClick={() => {
              if (!isRefreshing) {
                handleRefreshClick();
              }
            }}
            spin={isRefreshing}
          />
        </Space>
        <small>{totalCount} actions require attention</small>
      </div>
    </Space>
  );
};

export default ApprovalDrawerHeader;
